import React, { FC, ReactElement } from 'react'
import { BottomSheetProps } from '@yanolja-rnd/ya-com-bottom-sheet'
import ItemText from './ItemText'
import BottomSheet from '~/app/components/common/BottomSheet/BottomSheet'

/**
 * BottomSheetWithItemTet component
 * author: soojin.oh
 */

// type definitions
type Props = BottomSheetProps & {
  items: { title: string; id: string }[]
  selectedId: string
  onItemSelected: (id: string) => void
  headerAppend?: ReactElement
  testIdPrefix?: string
}

// BottomSheetWithItemTet component
const BottomSheetWithItemText: FC<Props> = function ({
  isOpened,
  title,
  onRequestClose,
  buttons,
  items,
  onItemSelected,
  selectedId,
  onBackgroundClick,
  headerAppend,
  testIdPrefix,
}) {
  return (
    <BottomSheet
      isOpened={isOpened}
      onRequestClose={onRequestClose}
      title={title}
      buttons={buttons}
      onBackgroundClick={onBackgroundClick}
      headerAppend={headerAppend}
    >
      {items.map(item => (
        <ItemText
          key={item.id}
          id={item.id}
          title={item.title}
          selected={item.id === selectedId}
          onClick={onItemSelected}
          testId={testIdPrefix ? item.id : `${testIdPrefix}-${item.id}`}
        />
      ))}
    </BottomSheet>
  )
}

export default BottomSheetWithItemText
